<template>
    <BaseSidebar
        :is-open="showExclusionsSidebar"
        :on-close="() => setExclusionsSidebar(false)"
        :show-header="true"
        :has-invitation-banner="hasInvitationBanner"
        custom-classes="bg-slate-50 dark:bg-slate-900/40"
    >
        <div class="h-full py-10 px-4">
            <div class="overflow-y-auto grow">
                <div class="lg:pt-10 mb-3">
                    <span v-if="card" class="block text-center">
                        <img
                            :src="card.image"
                            v-if="card && card.image"
                            class="mx-auto max-w-[10rem] lg:max-w-[60%]"
                        />
                    </span>
                </div>

                <div
                    class="text-center"
                    :class="{ 'mb-6': !card.topCard, 'p-4': card.topCard }"
                >
                    <i class="fas fa-info-circle text-orange fa-2x mb-5"></i>
                    <p class="text-gray-800 dark:text-gray-100">
                        Unfortunately you're likely ineligible for the
                    </p>
                    <p class="text-gray-800 dark:text-gray-100 font-bold text-lg">
                        {{ card.title }}
                    </p>
                    <p class="text-gray-800 dark:text-gray-100">for the following reasons:</p>
                </div>
                <div
                    class="text-center grid grid-cols-1 divide-y gap-3 px-3 pb-10"
                    v-if="!hasSet"
                >
                    <div
                        v-for="(exclusion, ex) in exclusions"
                        :key="'ex-' + ex"
                        class="pt-6 pb-3 px-3 col-span-1"
                    >
                        <p class="text-lg font-semibold leading-8">
                            <span class="text-orange">
                                <strong>{{ exclusion.title }}</strong>
                            </span>
                            {{ exclusion.type }}
                        </p>
                        <ExclusionText
                            :text="exclusion.text"
                            :hasTooltip="exclusion.hasTooltip"
                        />
                        <div v-if="exclusion.offenders.length > 0">
                            <!--<h5 class="font-semibold">
                                {{
                                    exclusion.offenders.length === 1
                                        ? "This Card"
                                        : "These Cards"
                                }}
                                Attribute to this Exclusion
                            </h5>-->
                        </div>
                        <div
                            v-for="(offender, of) in exclusion.offenders"
                            :key="'of-' + of"
                            class="text-sm"
                        >
                            ({{ offender.title }})
                        </div>
                    </div>
                </div>
                <div
                    class="text-center grid grid-cols-1 divide-y gap-3 px-3 pb-10"
                    v-if="hasSet"
                >
                    <div
                        v-for="(exclusion, exIndex) in exclusions"
                        :key="'ex-' + exIndex"
                        class="pt-6 pb-3 px-3 col-span-1"
                    >
                        <p class="text-lg font-semibold leading-8">
                            <span class="text-orange">
                                <strong>{{ exclusion.title }}</strong>
                            </span>
                            {{ exclusion.type }}
                        </p>
                        <ExclusionText
                            :text="exclusion.text"
                            :hasTooltip="exclusion.hasTooltip"
                        />

                        <div v-if="exclusion.offenders.length > 0">
                            <!--<h5 class="font-semibold">
                                {{
                                    exclusion.offenders.length === 1
                                        ? "This Card"
                                        : "These Cards"
                                }}
                                Attribute to this Exclusion
                            </h5>-->
                        </div>
                        <div
                            v-for="(offender, of) in exclusion.offenders"
                            :key="'of-' + of"
                            class="text-sm"
                        >
                            ({{ offender.title }})
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </BaseSidebar>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useNextCardStore } from '@/store/nextcard';
import ExclusionText from '@/components/next-card/exclusion-text.vue';
import BaseSidebar from '@/components/ui/base-sidebar.vue';

export default {
    components: {
        ExclusionText,
        BaseSidebar,
    },
    data: () => ({
        omitData: {
            type: Object,
            default: {},
        },
        hasInvitationBannerData: false,
    }),
    computed: {
        ...mapState(useNextCardStore, {
            showExclusionsSidebar: 'showExclusionsSidebar',
            card: 'activeNextCard',
            offenders: 'activeOffenders',
            user: 'activeUser',
        }),
        hasSet() {
            return this.card.omitted_results
                ? this.card.omitted_results.hasOwnProperty('sets')
                : false;
        },
        hasInvitationBanner() {
            return this.hasInvitationBannerData;
        },
        exclusions() {
            let exclusions = [];
            let uniques = [];
            if (this.hasSet) {
                this.card.omitted_results.sets.forEach((set) => {
                    set.reasons.forEach((reason) => {
                        uniques.push(reason);
                    });
                });

                let uniqueItems = [...new Set(uniques)];

                uniqueItems.forEach((unq) => {
                    exclusions.push(this.setExclusion(unq));
                });

                return exclusions;
            } else {
                if (
                    this.card.omitted_results &&
                    this.card.omitted_results.includes('current_card_holder') &&
                    this.card.omitted_results.includes(
                        'current_card_holder_family'
                    )
                ) {
                    this.card.omitted_results.splice(
                        this.card.omitted_results.indexOf(
                            'current_card_holder_family'
                        ),
                        1
                    );
                }

                if (this.card.omitted_results) {
                    this.card.omitted_results.forEach((el) => {
                        exclusions.push(this.setExclusion(el));
                    });
                }
            }
            return exclusions;
        },
    },
    methods: {
        ...mapActions(useNextCardStore, ['setExclusionsSidebar']),
        setExclusion(ex) {
            let obj = {
                title: '',
                type: '',
                text: '',
                offenders: [],
                hasTooltip: false,
            };
            let options = '';
            let extraData = '';
            switch (ex) {
                case 'five_twenty_four':
                    obj.title = 'Over 5/24';
                    obj.type = '';
                    obj.text =
                        "This card isn't available since you’re above 5/24.";
                    obj.text +=
                        ' <span class="text-sm text-slate-500 dark:text-slate-400 block mt-3">(Currently ' +
                        this.user.omitted_cards.five_twenty_four_count +
                        '/24)</span>';
                    obj.offenders = [];
                    break;
                case 'current_card_holder':
                    obj.title = 'Current Cardholder';
                    obj.type = '';
                    obj.text =
                        "You can't open a new version of this card while currently being a cardholder.";

                    obj.text += '';

                    if (this.offenders.hasOwnProperty('current_card_holder')) {
                        this.offenders['current_card_holder'].forEach(
                            (item) => {
                                obj.text +=
                                    '<div class="text-sm text-slate-500 dark:text-slate-400 block mt-3">(' +
                                    item.card_title +
                                    ' <span class="text-xs">' +
                                    item.last_four +
                                    '</span>)</div>';
                            }
                        );
                    }

                    obj.offenders = [];
                    break;
                case 'cardholder_another_card':
                    obj.title = 'Cardholder of Another Card';
                    obj.type = '';
                    obj.text =
                        "You can't open this card while currently being a cardholder of the following card(s).";

                    obj.text += '';

                    if (
                        this.offenders.hasOwnProperty('cardholder_another_card')
                    ) {
                        this.offenders['cardholder_another_card'].forEach(
                            (item) => {
                                obj.text +=
                                    '<div class="text-sm text-slate-500 dark:text-slate-400 block mt-3">(' +
                                    item.card_title +
                                    ' <span class="text-xs">' +
                                    item.last_four +
                                    '</span>)</div>';
                            }
                        );
                    }

                    obj.offenders = [];

                    break;
                case 'current_card_holder_family':
                    obj.title =
                        'Current ' +
                        this.card.family.name +
                        ' Family Cardholder';
                    obj.type = '';
                    obj.text =
                        "You can't open a new " +
                        this.card.family.name +
                        ' product while currently holding another card in the same product family.<br>';

                    obj.text += '';

                    if (
                        this.offenders.hasOwnProperty(
                            'current_card_holder_family'
                        )
                    ) {
                        this.offenders['current_card_holder_family'].forEach(
                            (item) => {
                                obj.text +=
                                    '<span class="text-sm text-slate-500 dark:text-slate-400 block mt-3">(' +
                                    item.card_title +
                                    ' <span class="text-xs">' +
                                    item.last_four +
                                    '</span>)</span>';
                            }
                        );
                    }

                    obj.offenders = [];
                    break;
                case 'time_since_bonus':
                    options = this.getCardRuleOptions('time_since_bonus');
                    let months = 0;
                    options[0].forEach((opt) => {
                        if (opt.key === 'time_since_bonus') {
                            months = opt.value;
                        }
                    });
                    obj.type = '';
                    if (months > 48) {
                        obj.title = 'Lifetime Bonus Restrictions';
                        obj.hasTooltip = false;
                        obj.text =
                            "You're likely ineligible to receive a bonus on a new " +
                            this.card.title +
                            ' Product since you have received a bonus on it.';
                    } else {
                        obj.title = months + ' Months Since Bonus';
                        obj.hasTooltip = true;
                        obj.text =
                            "You're likely ineligible to receive a bonus on a new " +
                            this.card.title +
                            ' Product since you received a bonus on it in the last ' +
                            months +
                            ' months.<br><span class="text-sm text-slate-500 dark:text-slate-400 block mt-3">(You\'ll be eligible again after approximately ';

                        if (this.offenders.hasOwnProperty('time_since_bonus')) {
                            obj.text += this.offenders['time_since_bonus']
                                .map((mess) => mess.fall_off_date)
                                .join(', ');
                        }

                        obj.text += ')</span>';
                    }
                    obj.offenders = [];
                    break;
                case 'time_since_closed':
                    options = this.getCardRuleOptions('time_since_closed');
                    obj.title = 'Time Since Closed on Another Card';
                    obj.type = '';
                    obj.text =
                        "You're likely ineligible to receive a bonus on a new " +
                        this.card.title;
                    obj.offenders = [];
                    break;
                case 'time_since_bonus_another_card':
                    options = this.getCardRuleOptions(
                        'time_since_bonus_another_card'
                    );
                    extraData = this.getExtraOmitData(
                        'time_since_bonus_another_card'
                    );
                    obj.title = 'Time Since Bonus on Another Card';
                    obj.type = '';
                    obj.text =
                        "You're likely ineligible to receive a bonus on a new " +
                        this.card.title +
                        ' Product since you received a bonus for the following:<br>';
                    //obj.text += extraData.card.title;
                    obj.hasTooltip = true;
                    obj.text += '';

                    if (
                        this.offenders.hasOwnProperty(
                            'time_since_bonus_another_card'
                        )
                    ) {
                        this.offenders['time_since_bonus_another_card'].forEach(
                            (item) => {
                                obj.text +=
                                    '<span class="text-sm text-slate-500 dark:text-slate-400 block mt-3">(' +
                                    item.card_title +
                                    ' <span class="text-xs">' +
                                    item.last_four +
                                    ' - ' +
                                    item.bonus_date +
                                    '</span>)</span>';
                            }
                        );
                    }

                    obj.offenders = [];

                    break;
                case 'have_or_have_had_in_time_period':
                    options = this.getCardRuleOptions(
                        'have_or_have_had_in_time_period'
                    );
                    obj.title = 'Have or Have Had in Time Period';
                    obj.type = '';
                    obj.text =
                        "You're likely ineligible to receive a bonus on a new " +
                        this.card.title +
                        ' Product since you received a bonus for the following: ';
                    obj.text += '';
                    obj.offenders = [];
                    break;
                case 'have_opened_recently':
                    options = this.getCardRuleOptions('have_opened_recently');
                    obj.title = 'Other Card Open Recently ';
                    obj.type = '';

                    obj.text =
                        "You're likely ineligible to receive a bonus on a new " +
                        this.card.title +
                        ' Product since you opened the following:<br>';

                    obj.hasTooltip = true;

                    if (this.offenders.hasOwnProperty('have_opened_recently')) {
                        this.offenders['have_opened_recently'].forEach(
                            (item) => {
                                obj.text +=
                                    '<span class="text-sm text-slate-500 dark:text-slate-400 block mt-3">(' +
                                    item.card_title +
                                    ' <span class="text-xs">' +
                                    item.last_four +
                                    ' - ' +
                                    item.date_opened +
                                    '</span>)</span>';
                            }
                        );
                    }

                    obj.offenders = [];
                    break;
                case 'amex_bonus_once_lifetime':
                    obj.title = 'AMEX Bonus Lifetime';
                    obj.type = 'Exclusion';
                    obj.text = 'Eligible again on: ';
                    obj.hasTooltip = true;

                    if (
                        this.offenders.hasOwnProperty(
                            'amex_bonus_once_lifetime'
                        )
                    ) {
                        this.offenders['amex_bonus_once_lifetime'].forEach(
                            (mess) => {
                                obj.text += mess.next_eligible_date;
                            }
                        );
                    }

                    obj.text += '';
                    obj.offenders = [];
                    break;
                default:
                    obj.title = 'Generic';
                    obj.type = 'Exclusion';
                    obj.text = 'Generic';
                    obj.offenders = [];
                    obj.hasTooltip = false;
            }

            return obj;
        },
        getRule(ruleName) {
            return JSON.parse(this.card.next_card_rules).filter((rule) => {
                return rule.name === ruleName;
            })[0];
        },
        getCardRuleOptions(ruleName) {
            const cardRules = JSON.parse(this.card.next_card_rules).find(
                (rule) => {
                    return rule.name === ruleName;
                }
            );

            if (!cardRules) {
                return [];
            }
            return cardRules.options ? cardRules.options : [];
        },
        getExtraOmitData(ruleName) {
            if (
                this.omitData.hasOwnProperty(this.card.id) &&
                this.omitData[this.card.id].hasOwnProperty(ruleName)
            ) {
                return this.omitData[this.card.id][ruleName];
            }
            return false;
        },
    },
    mounted() {
        this.hasInvitationBannerData =
            document.body.classList.contains('has-invitation');

        this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'class'
                ) {
                    this.hasInvitationBannerData =
                        document.body.classList.contains('has-invitation');
                }
            });
        });

        this.observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['class'],
        });
    },
    beforeUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    },
};
</script>
<style lang="scss">
.exclusions-sidebar {
    transform: translateX(100%);
    &.open {
        transform: translateX(0);
    }
}

@media (min-width: 768px) {
    body.sidebar-open {
        overflow: hidden;
    }

    .exclusions-sidebar.open + .main-content {
        padding-right: 28rem;
    }
}

@media (max-width: 767px) {
    .exclusions-sidebar.open {
        min-width: 100%;
        max-width: 100%;
    }
}
</style>
